export default __webpack_public_path__ + "static/media/regulatory--parking-restrictions--g2.231db037.png";